// see https://github.com/pimterry/loglevel
import { getLogger } from 'loglevel';
import { saveLog } from '@/store/api';

const logger = getLogger('default');
logger.setDefaultLevel(process.env.VUE_APP_LOGLEVEL);

export default {
    debug(mess: any) {
        logger.debug(mess);
    },
    error(mess: any) {
        if (process.env.VUE_APP_LOGLEVEL === 'trace') {
            const stackTrace = new Error().stack;
            saveLog(mess ? JSON.stringify(mess) : 'Errore generico ' + stackTrace);
        }
        logger.error(mess);
    },
};
